import { TrafficOriginType } from '@cc-shopping/contracts/credit-cards-page/constants';
import { useIsMounted } from '@cc-shopping/hooks/useIsMounted';
import { Paper, Popper } from '@mui/material';
import { MenuItems } from './MenuItems';
type SeeAllDesktopMenuProps = {
  activeNavId: string;
  detailsRef: React.RefObject<HTMLDetailsElement | null>;
  featureViewedActivityId: string;
  handleCloseMenu: () => void;
  isMenuOpen: boolean;
  trafficOriginType?: TrafficOriginType;
};
export const SeeAllDesktopMenu = ({
  activeNavId,
  detailsRef,
  featureViewedActivityId,
  handleCloseMenu,
  isMenuOpen,
  trafficOriginType = TrafficOriginType.Organic
}: SeeAllDesktopMenuProps) => {
  const isMounted = useIsMounted();
  const menuItems = <MenuItems trafficOriginType={trafficOriginType} activeNavId={activeNavId} isMenuOpen={isMenuOpen} onItemClickAction={handleCloseMenu} itemBorderRadius={1} analyticsProps={{
    featureViewedActivityId
  }} />;

  // We want to show this content even before page is mounted, so the links can be crawled
  // See this ticket for more details: https://nerdwallet.atlassian.net/browse/SHP-1130
  if (!isMounted) {
    return <Paper sx={{
      boxSizing: 'border-box',
      width: '272px',
      marginTop: 1,
      padding: 2,
      boxShadow: '0px 4px 8px 0px rgba(100, 102, 106, 0.1), 0px 1px 4px 0px rgba(100, 102, 106, 0.36)',
      maxHeight: '73vh',
      overflowY: 'auto',
      borderRadius: 2,
      zIndex: 10,
      position: 'absolute',
      right: 0,
      top: 'calc(100% + 2px)'
    }}>
        {menuItems}
      </Paper>;
  }
  return <Popper open={isMenuOpen} anchorEl={detailsRef.current} placement="bottom-end" disablePortal sx={{
    zIndex: 10
  }}>
      <Paper sx={{
      width: '272px',
      marginTop: 1,
      padding: 2,
      boxShadow: '0px 4px 8px 0px rgba(100, 102, 106, 0.1), 0px 1px 4px 0px rgba(100, 102, 106, 0.36)',
      maxHeight: '73vh',
      overflowY: 'auto',
      borderRadius: 2
    }}>
        {menuItems}
      </Paper>
    </Popper>;
};